import {useEffect, useRef, useState} from "react";
import {TextInput} from "@mantine/core";
import {useDebouncedValue} from "@mantine/hooks";

type SearchInputProps = {
    initialValue?: string;
    onChange: (value: string) => void;
    resetKey?: string | number;
};

export const SearchInput = ({
    initialValue = "",
    onChange,
}: SearchInputProps) => {
    const [value, setValue] = useState(initialValue);
    const [debounced] = useDebouncedValue(value, 600);
    const lastSent = useRef(initialValue);

    useEffect(() => {
        if (debounced !== lastSent.current) {
            lastSent.current = debounced;
            onChange(debounced);
        }
    }, [debounced, onChange]);

    return (
        <TextInput
            value={value}
            onChange={(e) => setValue(e.currentTarget.value)}
            size="sm"
            style={{flex: "1 1 10rem", minWidth: "8rem"}}
        />
    );
};
